import type { PerspectiveViewFilter } from "../../entities/perspective_view_filter";

// The grid's filters as an export should see them. The status card picks the
// tab, and the tab already picked the export, so it stays behind; a card with
// no value yet is still being typed and is dropped the way the viewer drops it
// before querying. Everything else goes to the export transforms and the PDF
// resolver as-is, where it is applied by whole PO after numbering.
const STATUS_COLUMN = "status";

const PO_TYPE_COLUMN = "po_type";

const isApplicable = (filter: unknown): filter is PerspectiveViewFilter =>
  Array.isArray(filter) &&
  filter.length === 3 &&
  typeof filter[0] === "string" &&
  filter[0] !== STATUS_COLUMN &&
  typeof filter[1] === "string" &&
  Array.isArray(filter[2]) &&
  filter[2].length > 0;

export const exportFiltersFrom = (filters: unknown): PerspectiveViewFilter[] =>
  Array.isArray(filters) ? filters.filter(isApplicable) : [];

/** The GraphQL shape the PDF resolver takes. */
export const toExportFilterInputs = (
  filters: ReadonlyArray<PerspectiveViewFilter>,
): { column: string; operator: string; values: string[] }[] =>
  filters.map(([column, operator, values]) => ({
    column,
    operator,
    values: values.map(String),
  }));

/** The PO types an `in` filter on the Approved tab's Type dropdown allows, or
 * null when nothing restricts them. Lets the Download skip a sheet that the
 * filter would empty anyway. */
export const allowedPoTypes = (
  filters: ReadonlyArray<PerspectiveViewFilter>,
): Set<string> | null => {
  const typeFilters = filters.filter(
    ([column, operator]) => column === PO_TYPE_COLUMN && operator === "in",
  );
  if (typeFilters.length === 0) return null;
  const allowed = new Set(typeFilters[0][2]);
  for (const [, , values] of typeFilters.slice(1)) {
    for (const value of [...allowed]) {
      if (!values.includes(value)) allowed.delete(value);
    }
  }
  return allowed;
};
